import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * SecciÃ³n de Perfil Personal
 * - Nombre, apellidos, email, telÃ©fono, idioma, tema, avatar
 * - Extensible para ediciÃ³n y validaciÃ³n
 * - Cumple con requisitos de serializaciÃ³n y trazabilidad
 */
export default function ProfileSection() {
    return (
        <Box>
            <Typography variant="h6">Perfil Personal</Typography>
            {/* TODO: Formulario de ediciÃ³n de perfil */}
            <Typography variant="body2" color="text.secondary">
                AquÃ­ podrÃ¡s editar tus datos personales, preferencias de idioma y tema, y tu avatar.
            </Typography>
        </Box>
    );
} 